import * as React from 'react';
import moment from 'moment';
import { GiCalendar } from "react-icons/gi";

import { MEDIA_BASE_URL } from '../../../config/constants';
import { StyledCard, Content, Row } from './LessonInfo.styles';


interface IProps {
  data?: any;
}

class LessonInfo extends React.Component<IProps> {
  public state = {};

  constructor(props) {
    super(props);
  }

  public render() {
    const { data } = this.props;
    const {
      Completion,
      Thumbnail,
      LastAttempt,
      BestScore,
    } = data;

    return (
      <StyledCard>
        <img src={`${MEDIA_BASE_URL}${Thumbnail}`} alt="lesson icon" />
        <Content>
          <Row>
            <h3>Your Last Attempt</h3>
            <p>
              <GiCalendar size="36px" color="#3ee9f7" />
              {moment(LastAttempt).format('lll')}
            </p>
          </Row>
          <Row>
            <h3>Completion</h3>
            <p className="yellow">{Completion}%</p>
          </Row>
          <Row>
            <h3>Score</h3>
            <p className="yellow">{BestScore.toFixed(2)}%</p>
          </Row>
        </Content>
      </StyledCard>
    );
  }
}

export default LessonInfo;



// WEBPACK FOOTER //
// ./src/components/DataCentre/LessonInfo/LessonInfo.tsx